import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BehaviorSubject } from 'rxjs';
import { DaveFilePreviewComponent, DaveFilePreviewComponentDialogData } from '../../../../../dave-file-preview-dialog/components/dave-file-preview/dave-file-preview.component';
import { ITaskBoardSort, TaskBoardFilter } from '../../../../../dave-tasks/components/tasks-board/tasks-board.component';
import { FormControl } from '@angular/forms';
export interface TaskBoardPopupComponentDialogData {
    filter: TaskBoardFilter;
    showSortButton?: boolean;
}
@Component({
    selector: 'app-task-board-popup',
    templateUrl: './task-board-popup.component.html',
    styleUrls: ['./task-board-popup.component.scss'],
})
export class TaskBoardPopupComponent {
    @ViewChild('input') private inputRef?: ElementRef<HTMLInputElement>;
    public static DefaultConfig: MatDialogConfig = {
        panelClass: ['custom-dialog-class-mobile-fullscreen'],
        width: '70rem',
        height: '70vh',
        maxWidth: '100%',
        maxHeight: '100%'
    };
    public SearchBarActive = false;
    public SearchForm = new FormControl<string>('');
    public TaskBoardSort: ITaskBoardSort = {sortBy: 'endDate', direction: 'dsc'};
    constructor(
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public Dialogdata: TaskBoardPopupComponentDialogData,
    ) {
    }
    OpenFile(fileId: number) {
        this.dialog.open<DaveFilePreviewComponent, DaveFilePreviewComponentDialogData>(DaveFilePreviewComponent, {
            ...DaveFilePreviewComponent.DefaultConfig,
            data: {
                fileId,
            },
        });
    }
    SearchButtonClicked() {
        if (!this.SearchBarActive) {
            this.SearchBarActive = true;
            setTimeout(() => this.inputRef?.nativeElement.focus(), 30);
        } else {
            if (this.SearchForm.value.length === 0) {
                this.SearchBarActive = false;
            }
        }
    }
}
